// extracted by mini-css-extract-plugin
export default {"galleryContainer":"gallary_galleryContainer__w1jS4","containerIMG":"gallary_containerIMG__JlCyw","allImgs":"gallary_allImgs__-feUp","active":"gallary_active__ouoxg"};